import loadable from '@loadable/component';

export const TheweekSiteWrapper = loadable(
  () => import(/* webpackChunkName: "theweek-site" */ './TheweekSiteWrapper'),
);
